import React from "react";

import * as SC from "./ExpressPreview.styled";
import { GTMDataLayerPush } from "../../Util/GoogleTagManager";
import { SquareButton } from "../Buttons";
import { AiCorrectorIcon } from "../Icons";

const ExpressPreview: React.FC = () => {
    const handleClick = () => {
        GTMDataLayerPush({
            event: "try_mentor_express_click",
        });
        window.open(`${process.env.REACT_APP_DUDENDE_URL}/user/register/private?source=mentor&type=duden-trial`, '_blank');
    }

    const renderFeatures = () => [
        'KI-gestützt',
        'komfortabel',
        'schnell und einfach',
    ].map(feature => <SC.Feature key={feature}>
        <SC.FeatureIcon>✓</SC.FeatureIcon>
        {feature}
    </SC.Feature>)

    return <SC.Wrapper>
        <SC.BackgroundPicture>
            <picture>
                <AiCorrectorIcon />
            </picture>
        </SC.BackgroundPicture>
        <SC.Content>
            <SC.Title>Neu: Mentor Express</SC.Title>
            <SC.Features>
                {renderFeatures()}
            </SC.Features>
            <SquareButton className="dark" onClick={handleClick}>Anmelden UND Testen →</SquareButton>
        </SC.Content>
    </SC.Wrapper>
}

export default ExpressPreview;